module.exports = __webpack_public_path__ + "static/integrations-ebfa92720c94e1b4ef91031a5b8f4f76.png";